__turbopack_context__.v({
  "color-accent": "Menu-module-scss-module__ielxsa__color-accent",
  "color-error": "Menu-module-scss-module__ielxsa__color-error",
  "color-primary": "Menu-module-scss-module__ielxsa__color-primary",
  "color-soft": "Menu-module-scss-module__ielxsa__color-soft",
  "color-success": "Menu-module-scss-module__ielxsa__color-success",
  "icon": "Menu-module-scss-module__ielxsa__icon",
  "item": "Menu-module-scss-module__ielxsa__item",
  "label": "Menu-module-scss-module__ielxsa__label",
  "menu": "Menu-module-scss-module__ielxsa__menu",
  "size-lg": "Menu-module-scss-module__ielxsa__size-lg",
  "size-md": "Menu-module-scss-module__ielxsa__size-md",
  "size-sm": "Menu-module-scss-module__ielxsa__size-sm",
});
